import { ErrorMessage, Field, FieldArray, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import TextError from "../../HealthInsFormikComponent/TextError";
import {
  occupationListForInsureds,
  relationshipWithProposerList,
} from "../../../PersonalAccident/QuickQuotePage/Helpers/constants";
import { Alert, Box, Snackbar, Typography } from "@mui/material";
import getInputFieldBorderClassName from "../../../PersonalAccident/QuickQuotePage/Helpers/getInputFieldBorderClassName";

const InsuredsFieldArray = (props) => {
  const { formik } = props;
  const { values } = useFormikContext();
  const [arrayObject, setArrayObject] = useState({});
  const insuredArrayName = "insureds";
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  useEffect(() => {
    let custObject = values[insuredArrayName][0];
    Object.entries(custObject).forEach((entry) => {
      custObject = { ...custObject, [entry[0]]: "" };
    });
    //console.log('custObject', custObject)
    setArrayObject(custObject);
  }, []);

  return (
    <>
      <Typography
        variant="h6"
        className="fw-bold HQ-title"
        style={{ marginTop: "24px", marginBottom: "16px" }}
      >
        Would you like to insure any additional members?
      </Typography>
      <FieldArray name={insuredArrayName}>
        {({ push, remove }) => (
          <>
            {values[insuredArrayName] &&
              Array.isArray(values[insuredArrayName]) &&
              values[insuredArrayName]?.length > 0 &&
              values[insuredArrayName]?.map((_, index) => (
                <div key={index}>
                  {index !== 0 && (
                    <Typography
                      variant="body1"
                      style={{ marginBottom: "8px", fontWeight: "bold" }}
                    >
                      Who would you like to get insured?
                    </Typography>
                  )}
                  {/* Relationship drop down layout */}
                  {index !== 0 && (
                    <RelationshipWithProposerSelectLayout
                      formik={formik}
                      name={`${insuredArrayName}[${index}].relationship_with_proposer`}
                    />
                  )}

                  {(values?.[insuredArrayName]?.[index]
                    ?.relationship_with_proposer ?? "") !== "" && (
                    <div>
                      {/* Proposer Name layout */}
                      <InsuredNameLayout
                        formik={formik}
                        name={`${insuredArrayName}[${index}].first_name`}
                      />

                      {/* Annual Income layout */}
                      <AnnualIncomeLayout
                        formik={formik}
                        name={`${insuredArrayName}[${index}].annual_income`}
                      />
                      {/* Occupation drop down layout */}
                      <OccupationSelectLayout
                        formik={formik}
                        name={`${insuredArrayName}[${index}].occupation`}
                      />

                      {/* Remove button  */}
                      <Box
                        sx={{
                          marginBottom: 3,
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Typography
                          component="p"
                          variant="body1"
                          sx={{ color: "error.main", cursor: "pointer" }}
                          onClick={() => remove(index)}
                        >
                          Remove
                        </Typography>
                      </Box>
                    </div>
                  )}
                </div>
              ))}

            {/* Add member button */}
            <Box
              sx={{
                marginTop: 2,
                marginBottom: 4,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                type="button"
                className="btn btn-success text-dark"
                onClick={() => {
                  // In PA max four members are allowed including proposer
                  if (values[insuredArrayName]?.length < 4) push(arrayObject);
                  else setSnackbarOpen(true);
                }}
              >
                <i className="bi bi-plus"></i>
                Add Member
              </button>
              <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <Alert
                  onClose={handleSnackbarClose}
                  severity="error"
                  sx={{ width: "100%" }}
                >
                  Max four persons are allowed
                </Alert>
              </Snackbar>
            </Box>
          </>
        )}
      </FieldArray>
    </>
  );
};

const InsuredNameLayout = ({ formik, name }) => {
  return (
    <div className="form-group mb-3" style={{ paddingTop: "20px" }}>
      <Typography
        htmlFor={name}
        variant="body1"
        className="fw-light"
        style={{ paddingBottom: "8px" }}
      >
        First Name
      </Typography>
      <div className="input-icons">
        <Field
          type="text"
          name={name}
          id={name}
          className={getInputFieldBorderClassName(formik, name)}
        />
      </div>
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

const RelationshipWithProposerSelectLayout = ({ formik, name }) => {
  return (
    <div className="form-group mb-3 ">
      <Field
        as="select"
        name={name}
        id={name}
        className={getInputFieldBorderClassName(formik, name)}
      >
        <option value="">Select Member</option>
        {relationshipWithProposerList.map((item) => (
          <option key={item.id} value={item.id}>
            {item.value}
          </option>
        ))}
      </Field>
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

const OccupationSelectLayout = ({ formik, name }) => {
  return (
    <div className="form-group mb-3 ">
      <Typography htmlFor={name} variant="body1">
        Occupation
      </Typography>
      <Field
        as="select"
        name={name}
        id={name}
        className={getInputFieldBorderClassName(formik, name)}
      >
        <option value="">Select Occupation</option>
        {occupationListForInsureds.map((item) => (
          <option key={item.id} value={item.id}>
            {item.value}
          </option>
        ))}
      </Field>
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

const AnnualIncomeLayout = ({ formik, name }) => {
  return (
    <div className="form-group mb-3">
      <Typography htmlFor={name} variant="body1">
        Annual Income
      </Typography>
      <div className="input-icons">
        <Field
          type="number"
          name={name}
          id={name}
          className={getInputFieldBorderClassName(formik, name)}
          aria-describedby="nameHelp"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          onWheel={(e) => e.currentTarget.blur()}
        />
      </div>

      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

export default InsuredsFieldArray;
